import { useOnScroll } from "hooks/useOnScroll";
import { useState } from "react";

export const useRenderCompactSummary = (rankingsSummaryRef, isMobile) => {
    const [renderCompactSummary, setRenderCompactSummary] = useState(false);

    const { scrollerRef } = useOnScroll(e => {
        const wrappingTextOffset = rankingsSummaryRef.current?.clientHeight > 100 ? isMobile ? 65 : 80 : 0;
        if (e.target.scrollTop > (isMobile ? 0 : 50) + wrappingTextOffset && !renderCompactSummary) setRenderCompactSummary(true);
        if (e.target.scrollTop <= (isMobile ? 0 : 50) + wrappingTextOffset && renderCompactSummary) setRenderCompactSummary(false);
    });

    return { scrollerRef, renderCompactSummary };
};
